import { createFileRoute } from '@tanstack/react-router'
import { UnauthorizedCdrsPage } from '@/features/finance/cdrs/pages/unauthorized-cdrs-page'
import { requireRole } from '@/lib/auth-guards'

export const Route = createFileRoute('/_authenticated/cdrs/unauthorized/')({
  component: UnauthorizedCdrsPage,
  beforeLoad: requireRole(['admin']),
})
